export default __webpack_public_path__ + "static/media/banneddeleteduserpic.0e863564.svg";